"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openid_sign_in_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../main");
const user_1 = require("../user");
const access_auth_thunk_1 = require("./access_auth_thunk");
const openid_sign_in_1 = require("../../../../api/calls/user/openid_sign_in");
exports.openid_sign_in_thunk = (0, toolkit_1.createAsyncThunk)("user/openid_sign_in_thunk", ({ code }, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    // Indicate that the API is being called.
    yield dispatch((0, user_1.setIsLoading)(true));
    // Call the API.
    let response = null;
    if (code) {
        dispatch((0, user_1.setFaceTecAuthorized)(true));
    }
    response = yield (0, openid_sign_in_1.openid_sign_in)({ code: code !== null && code !== void 0 ? code : "" });
    // Indicate that the API is done being called.
    yield dispatch((0, user_1.setIsLoading)(false));
    // Handle the response.
    if (response.success) {
        dispatch((0, access_auth_thunk_1.get_access_details_thunk)({ data: { code }, token: response.content.token }));
        dispatch((0, user_1.setUserToken)(response.content.token));
        dispatch((0, user_1.setUser)(response.content.user));
        return response.content;
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
    return null;
}));
